import { Link } from "react-router-dom";
import { CATEGORIES } from "../lib/categories";

export default function CategoryTiles({ posts }) {
  const coverFor = (name) => posts.find((p) => p.category === name)?.cover_image;
  const countFor = (name) => posts.filter((p) => p.category === name).length;

  return (
    <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-14 md:py-20" data-testid="category-tiles">
      <div className="mb-8 md:mb-10">
        <p className="overline">Explore the journal</p>
      </div>
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {CATEGORIES.map((c) => (
          <li key={c.slug}>
            <Link to={`/category/${c.slug}`} className="tile aspect-[16/10] lg:aspect-[4/3]" data-testid={`tile-${c.slug}`}>
              {coverFor(c.name) && (
                <img src={coverFor(c.name)} alt="" loading="lazy" decoding="async" />
              )}
              <div className="tile-label">
                <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-[#c9a45c] mb-2">
                  {countFor(c.name)} {countFor(c.name) === 1 ? "article" : "articles"}
                </p>
                <h3 className="font-serif text-2xl md:text-[1.65rem] font-medium leading-[1.05]">{c.name}</h3>
                <span className="tile-cta">Explore →</span>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
